if ($('.contact form').length > 0) {
    $('.contact form').parsley();
}

$(".contact form .btn").on("click", function() {

    // Google Analytics
    ga('send', 'event', 'Contact Form', 'Submission', 'The contact form has been submitted');

    // Google Adwords
    gtag('event', 'conversion', {
        'send_to': 'AW-1055978349/8eu7CLjVk5ADEO3mw_cD',
    });

});